function SvgPaperPen(props) {
  return (
    <svg viewBox="0 0 21 22" width="1em" height="1em" {...props}>
      <g>
        <path d="M19.009 7.756l-8.696 8.693-.682-.682 8.696-8.692.682.681zm-9.531 9.378l-1.006.467.47-1.002.536.535zM20.9 6.604a.538.538 0 00-.158-.383l-.885-.884a.534.534 0 00-.754 0l-.51.51a.534.534 0 00-.643.086l-9.7 9.696a.535.535 0 00-.108.153l-1.27 2.7a.544.544 0 00.107.614.53.53 0 00.602.108l2.711-1.26a.535.535 0 00.152-.107l9.703-9.698a.539.539 0 00.09-.646l.505-.505a.54.54 0 00.158-.384z" />
        <path d="M13.22 1.436l2.488 2.669H13.22V1.436zm2.64 5.913c.406-.473.757-.984 1.16-1.455V3.646a.699.699 0 00-.17-.438L13.812.17a.7.7 0 00-.437-.17H.608A.602.602 0 000 .608v20.66c0 .34.267.607.608.607h15.805c.34 0 .608-.267.608-.607V12.82c-.065.063-.929 1.106-1.216 1.439v6.4H1.215V1.216H12.14v3.99h3.666v2.201l.055-.057z" />
      </g>
    </svg>
  );
}

export default SvgPaperPen;
